import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getRestaurantsByRatings} from 'api/requests';
import {QueryKeyEnum} from 'types';
import {IRestaurantsByRatingRequest, IRestaurantsByRatingResponse} from 'types';

export const useRestaurantsByRatings = (
  query: IRestaurantsByRatingRequest,
  options: UseQueryOptions<IRestaurantsByRatingResponse>,
) => {
  return useQuery<IRestaurantsByRatingResponse>({
    queryKey: [QueryKeyEnum.RESTAURANT_BY_RATINGS, query.slug],
    queryFn: () => getRestaurantsByRatings(query),
    ...options,
  });
};
